module.exports = __webpack_public_path__ + "img/3b0adb1.png";